import React, { useId } from 'react';
import cx from 'classnames';

import { InputAutocomplete } from '../shared';

interface TextAreaInputProps {
  label: string;
  placeholder?: string;
  value?: string;
  autoComplete?: InputAutocomplete;
  minLength?: number;
  maxLength: number;
  required?: boolean;
  handleOnChange?: (event: React.ChangeEvent, value: string) => void;
}

export function TextAreaInput({
  label,
  placeholder,
  autoComplete,
  minLength = 1,
  maxLength = 140,
  required = false,
  value,
  handleOnChange
}: TextAreaInputProps) {
  const inputId = useId();
  const charsRemaining = maxLength - [...(value ?? '')].length;

  return (
    <div className="flex flex-col">
      <div className="relative h-[120px] w-full rounded-input-box-shape border border-teal">
        <label
          htmlFor={inputId}
          className={cx(
            'absolute -mt-2 ml-4 rounded-input-box-shape bg-white px-1 text-[0.8em] font-medium'
          )}
        >
          {label}
          {required ? '*' : ''}
        </label>
        <textarea
          data-testid="text-area-input"
          id={inputId}
          required={required}
          placeholder={placeholder ?? ''}
          autoComplete={autoComplete ?? 'off'}
          minLength={minLength}
          maxLength={maxLength}
          onChange={(e) => {
            if (handleOnChange) handleOnChange(e, e.target.value);
          }}
          value={value}
          aria-required={required}
          className={cx(
            'h-full w-full resize-none rounded-input-box-shape border-none p-4 leading-[1.5] focus:border-none focus:outline-none'
          )}
        />
      </div>
      <p className="typography-body-2 px-2 py-3 text-right leading-[22px]">
        {`${charsRemaining} characters remaining`}
      </p>
    </div>
  );
}
